function addAriaLabels() {
  const emailInput = document.querySelector('.tree-rendered-text-input');
  if (emailInput && !emailInput.getAttribute('aria-label')) {
    emailInput.setAttribute('aria-label', 'Enter your email here');
  }

  const searchBox = document.querySelector('#cc-search-box');
  if (searchBox && !searchBox.getAttribute('aria-label')) {
    searchBox.setAttribute('aria-label', 'Search here');
  }
}

// Run immediately
addAriaLabels();

// Keep checking because 3rd-party elements may load late
const interval = setInterval(() => {
  addAriaLabels();

  // Stop checking once both are found
  const emailInput = document.querySelector('.tree-rendered-text-input');
  const searchBox = document.querySelector('#cc-search-box');

  if (emailInput && searchBox) {
    clearInterval(interval);
  }
}, 1000);

(function () {

  let runCount = 0;

  function applyAccessibilityFixes() {
    runCount++;

    /*
    ==========================================
    1. Email Input
    ==========================================
    */
    const emailInput = document.querySelector(".tree-rendered-text-input");

    if (emailInput) {
      emailInput.setAttribute("aria-label", "Enter your email here");
    }

    /*
    ==========================================
    2. Search Box
    ==========================================
    */
    const searchBox = document.querySelector("#cc-search-box");

    if (searchBox) {
      searchBox.setAttribute("aria-label", "Search here");
    }

    /*
    ==========================================
    3. Ask Question Box
    ==========================================
    */
    const askQuestionBox = document.querySelector("#ask-question-box");

    if (askQuestionBox) {
      askQuestionBox.setAttribute("aria-label", "Ask question");
    }

    /*
    ==========================================
    4. Textarea Placeholder
    ==========================================
    */
    const textarea = document.querySelector(
      'textarea[placeholder="You may enter any other details to clarify your question here (optional)..."]'
    );

    if (textarea) {
      const placeholderText =
        "You may enter any other details to clarify your question here (optional)...";

      textarea.setAttribute("aria-label", placeholderText);
    }

    /*
    ==========================================
    5. Toggle Comments Hide
    ==========================================
    */
    const toggleComments = document.querySelectorAll(
      ".toggle-comments.hide"
    );

    if (toggleComments.length > 0) {
      toggleComments.forEach((element, index) => {
        element.setAttribute("aria-hidden", "true");
        element.setAttribute("aria-label", "empty comment");
      });
    }
  }

  /*
  ==========================================
  Initial Run
  ==========================================
  */
  applyAccessibilityFixes();

  /*
  ==========================================
  Keep Checking Every 1 Second
  ==========================================
  */
  setInterval(() => {
    applyAccessibilityFixes();
  }, 1000);

  /*
  ==========================================
  Watch DOM Changes
  ==========================================
  */
  const observer = new MutationObserver((mutations) => {
    applyAccessibilityFixes();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

})();

(function () {

  let scanCount = 0;

  function applyFixes() {
    scanCount++;

    /*
    =====================================================
    1. Remove aria-labelledby from .sa-rating.d-inline-block
    =====================================================
    */
    const ratings = document.querySelectorAll(
      ".sa-rating.d-inline-block"
    );

    if (ratings.length) {
      ratings.forEach((el, index) => {
        if (el.hasAttribute("aria-labelledby")) {
          el.removeAttribute("aria-labelledby");
        }
      });
    }

    /*
    =====================================================
    2. .cache.d-inline-block images -> alt=""
    =====================================================
    */
    const cacheImages = document.querySelectorAll(
      ".cache.d-inline-block img"
    );

    if (cacheImages.length) {
      cacheImages.forEach((img, index) => {
        img.setAttribute("alt", "");
      });
    }

    /*
    =====================================================
    3. Dropzone preview images -> alt=""
    =====================================================
    */
    const dzImages = document.querySelectorAll(
      '.dz-preview.dz-file-preview img[data-dz-thumbnail]'
    );

    if (dzImages.length) {
      dzImages.forEach((img, index) => {
        img.setAttribute("alt", "");
      });
    }

    /*
    =====================================================
    4. .custom-file-label img -> alt=""
    =====================================================
    */
    const customLabelImages = document.querySelectorAll(
      ".custom-file-label img"
    );

    if (customLabelImages.length) {
      customLabelImages.forEach((img, index) => {
        img.setAttribute("alt", "");
      });
    }
  }

  /*
  =====================================================
  Initial Run
  =====================================================
  */
  applyFixes();

  /*
  =====================================================
  Keep Checking Every 1 Second
  =====================================================
  */
  setInterval(() => {
    applyFixes();
  }, 1000);

  /*
  =====================================================
  Watch Dynamic DOM Changes
  =====================================================
  */
  const observer = new MutationObserver(() => {
    applyFixes();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

})();

(function () {

  let scanCount = 0;

  function setAriaLabel(element, label) {
    if (!element) return;

    element.setAttribute("aria-label", label);
  }

  function applyAccessibilityFixes() {
    scanCount++;

    /*
    ==================================================
    1. Email Address
    ==================================================
    */
    const bisEmail = document.querySelector("#bis-email");

    if (bisEmail) {
      const label =
        bisEmail.getAttribute("placeholder") ||
        bisEmail.value ||
        "Email Address";

      setAriaLabel(bisEmail, label);
    }

    /*
    ==================================================
    2. Mobile Number
    ==================================================
    */
    const bisPhone = document.querySelector("#bis-phone");

    if (bisPhone) {
      const label =
        bisPhone.getAttribute("placeholder") ||
        bisPhone.value ||
        "Mobile Number";

      setAriaLabel(bisPhone, label);
    }

    /*
    ==================================================
    3. reqFiller
    ==================================================
    */
    const reqFiller = document.querySelector("#reqFiller");

    if (reqFiller) {
      const label =
        reqFiller.value ||
        reqFiller.getAttribute("placeholder") ||
        "Request Filler";

      setAriaLabel(reqFiller, label);
    }

    /*
    ==================================================
    4. reviewCollect
    ==================================================
    */
    const reviewCollect = document.querySelector("#reviewCollect");

    if (reviewCollect) {
      const label =
        reviewCollect.value ||
        reviewCollect.getAttribute("placeholder") ||
        "Review Collect";

      setAriaLabel(reviewCollect, label);
    }

    /*
    ==================================================
    5. Product Related Hidden Inputs
    ==================================================
    */
    const productId = document.querySelector("#productId");

    if (productId) {
      const label =
        productId.value ||
        productId.getAttribute("placeholder") ||
        "Product ID";

      setAriaLabel(productId, label);
    }

    const pId = document.querySelector("#pId");

    if (pId) {
      const label =
        pId.value ||
        pId.getAttribute("placeholder") ||
        "Product Internal ID";

      setAriaLabel(pId, label);
    }

    const productDescription =
      document.querySelector("#productDescription");

    if (productDescription) {
      const label =
        productDescription.value ||
        productDescription.getAttribute("placeholder") ||
        "Product Description";

      setAriaLabel(productDescription, label);
    }

    /*
    ==================================================
    6. Feedback Textarea
    ==================================================
    */
    const feedbackBox = document.querySelector("#feedback_box");

    if (feedbackBox) {
      const label =
        feedbackBox.getAttribute("placeholder") ||
        feedbackBox.value ||
        "Write your review here";

      setAriaLabel(feedbackBox, label);
    }

    /*
    ==================================================
    7. Heading Textarea
    ==================================================
    */
    const heading = document.querySelector("#heading");

    if (heading) {
      const label =
        heading.getAttribute("placeholder") ||
        heading.value ||
        "Review Heading";

      setAriaLabel(heading, label);
    }

    /*
    ==================================================
    8. Order ID
    ==================================================
    */
    const orderId = document.querySelector("#orderId");

    if (orderId) {
      const label =
        orderId.getAttribute("placeholder") ||
        orderId.value ||
        "Order ID";

      setAriaLabel(orderId, label);
    }

    /*
    ==================================================
    9. Display Name
    ==================================================
    */
    const displayname = document.querySelector("#displayname");

    if (displayname) {
      const label =
        displayname.getAttribute("placeholder") ||
        displayname.value ||
        "Display Name";

      setAriaLabel(displayname, label);
    }

    /*
    ==================================================
    10. Email Used On Order
    ==================================================
    */
    const email = document.querySelector("#email");

    if (email) {
      const label =
        email.getAttribute("placeholder") ||
        email.value ||
        "Email used on order";

      setAriaLabel(email, label);
    }

    /*
    ==================================================
    11. File Upload Input
    ==================================================
    */
    const fileInputs = document.querySelectorAll(
      '.dz-hidden-input[type="file"]'
    );

    if (fileInputs.length > 0) {
      fileInputs.forEach((input, index) => {
        const label =
          input.getAttribute("placeholder") ||
          input.value ||
          "Upload images";

        setAriaLabel(input, label);
      });
    }
  }

  /*
  ==================================================
  Initial Run
  ==================================================
  */
  applyAccessibilityFixes();

  /*
  ==================================================
  Recheck Every 1 Second
  ==================================================
  */
  setInterval(() => {
    applyAccessibilityFixes();
  }, 1000);

  /*
  ==================================================
  Watch DOM Changes
  ==================================================
  */
  const observer = new MutationObserver(() => {
    applyAccessibilityFixes();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

})();

// reviews
(function () {

  const processed = new WeakSet();

  function fixRatings() {
    /*
    ==========================================
    1. Fix SA__rating (focusable rating)
    ==========================================
    */
    document.querySelectorAll(".SA__rating").forEach((el, i) => {
      if (processed.has(el)) return;
      processed.add(el);

      // Ensure correct role
      if (!el.getAttribute("role")) {
        el.setAttribute("role", "img");
      }

      // Ensure aria-label exists (keep existing if present)
      if (!el.getAttribute("aria-label")) {
        el.setAttribute("aria-label", "Rating");
      }
    });

    /*
    ==========================================
    2. Fix SA__stars (rating container)
    ==========================================
    */
    document.querySelectorAll(".SA__stars").forEach((el, i) => {
      if (processed.has(el)) return;
      processed.add(el);

      // Rating container should NOT be interactive
      if (!el.getAttribute("role")) {
        el.setAttribute("role", "img");
      }

      // If aria-label exists, keep it
      const label = el.getAttribute("aria-label");
      if (!label) {
        el.setAttribute("aria-label", "Product rating");
      }
    });

    /*
    ==========================================
    3. Fix star SVGs (decorative only)
    ==========================================
    */
    document.querySelectorAll(".SA__star svg").forEach((svg) => {
      svg.setAttribute("aria-hidden", "true");
      svg.setAttribute("focusable", "false");
    });
  }

  /*
  ==========================================
  INITIAL RUN
  ==========================================
  */
  fixRatings();

  /*
  ==========================================
  INTERVAL (for late load systems)
  ==========================================
  */
  const interval = setInterval(() => {
    fixRatings();
  }, 1000);

  /*
  ==========================================
  MUTATION OBSERVER (Flickity / SPA safe)
  ==========================================
  */
  const observer = new MutationObserver(() => {
    fixRatings();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

  /*
  ==========================================
  AUTO STOP AFTER STABILIZATION
  ==========================================
  */
  setTimeout(() => {
    clearInterval(interval);
    observer.disconnect();
  }, 30000);
})();

// reviews select
(function () {

  const processed = new WeakSet();

  function setAria(select, label) {
    if (!select || processed.has(select)) return;

    processed.add(select);

    if (!select.getAttribute("aria-label")) {
      select.setAttribute("aria-label", label);
    }
  }

  function fixSelects() {
    const select1 = document.querySelector("#widget-filter");
    const select2 = document.querySelector("#widget-filter2");

    if (select1) {
      setAria(select1, "Widget Filter");
    }

    if (select2) {
      setAria(select2, "Widget Filter 2");
    }
  }

  // Initial run
  fixSelects();

  // Late load support (3rd-party widgets)
  const interval = setInterval(() => {
    fixSelects();
  }, 1000);

  const observer = new MutationObserver(() => {
    fixSelects();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

  // Stop after stable load
  setTimeout(() => {
    clearInterval(interval);
    observer.disconnect();
  }, 30000);
})();

// arrows
(function () {
  const processed = new WeakSet();

  function fixArrows() {
    const rightArrows = document.querySelectorAll(".cc-arrow-right");
    const leftArrows = document.querySelectorAll(".cc-arrow-left");

    function apply(el, title) {
      if (!el || processed.has(el)) return;

      processed.add(el);

      if (!el.getAttribute("title")) {
        el.setAttribute("title", title);
      }
    }

    rightArrows.forEach((el) => {
      apply(el, "Right Arrow");
    });

    leftArrows.forEach((el) => {
      apply(el, "Left Arrow");
    });
  }

  fixArrows();

  const interval = setInterval(() => {
    fixArrows();
  }, 1000);

  const observer = new MutationObserver(() => {
    fixArrows();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

  setTimeout(() => {
    clearInterval(interval);
    observer.disconnect();
  }, 30000);
})();

// change heading tag in review
(function () {
  const processed = new WeakSet();

  function fixHeadings() {
    const headings = document.querySelectorAll(
      ".answerbase-widget .cell h5[data-text-title], .questions-list .cell h5"
    );

    if (!headings.length) return;

    headings.forEach((el) => {
      if (processed.has(el)) return;

      processed.add(el);

      if (!el.classList.contains("h5")) {
        el.classList.add("h5");
      }

      const h2 = document.createElement("h2");

      for (const attr of el.attributes) {
        h2.setAttribute(attr.name, attr.value);
      }

      h2.className = el.className;
      h2.innerHTML = el.innerHTML;

      el.parentNode.replaceChild(h2, el);
    });
  }

  fixHeadings();

  const interval = setInterval(() => {
    fixHeadings();
  }, 1000);

  const observer = new MutationObserver(() => {
    fixHeadings();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

  setTimeout(() => {
    clearInterval(interval);
    observer.disconnect();
  }, 30000);
})();

window.addEventListener("load", function () {
  function removeGalleryAria() {
    const galleryCells = document.querySelectorAll(".gallery-cell");

    galleryCells.forEach((cell) => {
      if (cell.hasAttribute("aria-selected")) {
        cell.removeAttribute("aria-selected");
      }
    });
  }

  removeGalleryAria();

  setInterval(removeGalleryAria, 500);
});

function addSliderAccessibility() {
  const slider = document.querySelector('.testimonials-slider.flickity-enabled');

  if (slider && !slider.hasAttribute('role')) {
    slider.setAttribute('role', 'region');
    slider.setAttribute('aria-label', 'Customer testimonials carousel');
  }
}

addSliderAccessibility();

const observer = new MutationObserver(addSliderAccessibility);
observer.observe(document.body, {
  childList: true,
  subtree: true
});

// ADA
function fixGoogleMapAreas() {
  const areas = document.querySelectorAll('map area');

  areas.forEach((area, index) => {
    area.setAttribute('alt', `Google Map Area ${index + 1}`);
    area.setAttribute('aria-label', `Google Map Area ${index + 1}`);
  });
}

fixGoogleMapAreas();
setInterval(fixGoogleMapAreas, 2000);

function addArrowLabels() {
  const leftArrows = document.querySelectorAll('.cc-arrow-left');
  const rightArrows = document.querySelectorAll('.cc-arrow-right');

  leftArrows.forEach((arrow) => {
    arrow.setAttribute('aria-label', 'Left Arrow');
  });

  rightArrows.forEach((arrow) => {
    arrow.setAttribute('aria-label', 'Right Arrow');
  });
}

addArrowLabels();
setInterval(addArrowLabels, 2000);

 // Function to remove aria-selected from testimonial cells
(function() {
  // Function to remove aria-selected from all testimonial cells
  function removeAriaSelected() {
    const cells = document.querySelectorAll('.testimonial-cell');
    cells.forEach(cell => {
      if (cell.hasAttribute('aria-selected')) {
        cell.removeAttribute('aria-selected');
      }
    });
  }

  // Initial run
  removeAriaSelected();

  // Observe any DOM changes (e.g., carousel adding 'aria-selected')
  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      if (mutation.type === 'attributes' && mutation.attributeName === 'aria-selected') {
        removeAriaSelected(); // Remove immediately
      }
      if (mutation.type === 'childList') {
        removeAriaSelected(); // Remove from newly added nodes
      }
    });
  });

  observer.observe(document.body, {
    attributes: true,
    subtree: true,
    attributeFilter: ['aria-selected'],
    childList: true
  });

  // Backup interval (extra safety in case carousel re-adds it via JS)
  setInterval(removeAriaSelected, 300);
})();